import { List, Typography, Avatar, Flex, Card, Rate, Image, Modal, Button } from "antd";
import { ABOUT_KARNCY, BTN_TXT } from "../../constants/constants";
import Logo from "../../assets/images/auth-logo.png";
import { UserOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import "./AuthSidebar.scss";

const { Title } = Typography;

const AuthSidebar = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const review = ABOUT_KARNCY.TESTIMONIALS.REVIEW;
    const truncated = review.length > 150 ? review.slice(0, 150) + "..." : review;

    return (
        <div className="auth-sidebar-container">
            <div className="logo">
                <Image preview={false} src={Logo} alt="Logo" />
            </div>
            <Title>{ABOUT_KARNCY.KARNCY_USERS_DESC}</Title>
            <List
                dataSource={ABOUT_KARNCY.ABOUT_LIST_DATA}
                size="small"
                className="custom-list-border"
                renderItem={(item, index) => (
                    <List.Item key={index}>
                        <Flex align="center" justify="flex-start" gap={10}>
                            <Avatar src={item.icon} shape="square" style={{ width: 24, height: 24 }} />
                            <Typography>{item.title}</Typography>
                        </Flex>
                    </List.Item>
                )}
            />
            <Card style={{ marginTop: 30 }}>
                <Flex align="center" justify="space-between">
                    <Flex align="center" justify="flex-start" gap={10}>
                        <Avatar shape="circle" icon={<UserOutlined />} />
                        <Typography style={{ fontWeight: "bold" }}>
                            {ABOUT_KARNCY.TESTIMONIALS.NAME}
                        </Typography>
                    </Flex>
                    <Rate disabled defaultValue={ABOUT_KARNCY.TESTIMONIALS.RATING} />
                </Flex>

                <Typography style={{ marginTop: 20 }}>
                    {review.length > 150 ? truncated : review}
                </Typography>

                {review.length > 150 && (
                    <Button
                        type="link"
                        onClick={() => setIsModalVisible(true)}
                        style={{ paddingLeft: 0 }}
                    >
                        {BTN_TXT.READ_MORE}
                    </Button>
                )}

                <Modal
                    title="User Testimonial"
                    open={isModalVisible}
                    onCancel={() => setIsModalVisible(false)}
                    footer={null}
                >
                    <Typography>{review}</Typography>
                </Modal>
            </Card>
        </div>
    );
};

export default AuthSidebar;
